import RemoveIcon from "@mui/icons-material/CloseRounded";
import EditIcon from "@mui/icons-material/EditOutlined";
import { Button } from "@mui/material";

interface Props {
  selectedIds: string[];
  onEditSelectedUsers: (ids: string[]) => void;
  onRemoveSelectedUsers: (ids: string[]) => void;
}

const UserAccessMatrixGridToolbar = ({ selectedIds, onEditSelectedUsers, onRemoveSelectedUsers }: Props) => {
  return (
    <>
      <Button
        color="secondary"
        variant="text"
        startIcon={<EditIcon />}
        onClick={() => onEditSelectedUsers(selectedIds)}
      >
        Bulk Edit
      </Button>
      <Button
        color="error"
        variant="text"
        startIcon={<RemoveIcon />}
        onClick={() => onRemoveSelectedUsers(selectedIds)}
      >
        Remove
      </Button>
    </>
  );
};

export default UserAccessMatrixGridToolbar;
